module.exports = __webpack_public_path__ + "img/add-def.31d55044.png";